import { render, staticRenderFns } from "./TipsText.vue?vue&type=template&id=2a634986&scoped=true"
import script from "./TipsText.vue?vue&type=script&lang=js"
export * from "./TipsText.vue?vue&type=script&lang=js"
import style0 from "./TipsText.vue?vue&type=style&index=0&id=2a634986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a634986",
  null
  
)

export default component.exports